export default class Zoomer {
    constructor(options) {
        if (options.trigger) {
            this.trigger = typeof (options.trigger) === 'string' ? document.querySelector(options.trigger) : options.trigger;
        }
        this.images = Array.from(typeof (options.image) === 'string' ? document.querySelectorAll(options.images) : options.images);
        this.aligner = typeof (options.trigger) === 'string' ? document.querySelector(options.aligner) : options.aligner;
    }

    init() {
        this.imageSizes = {};
        this._createElements();
        if (this.trigger) {
            this.enabled = false;
            this.trigger.addEventListener('click', this.toggle.bind(this));
        }
        else {
            this.enable();
        }
    }

    _createElements() {
        this.zoomPanel = document.createElement('div');
        this.zoomPanel.classList.add('zoom-panel');
        this.overlays = [];
        this.overlayMarkers = [];
        document.body.appendChild(this.zoomPanel);
        this.images.forEach((image, i) => {
            image.event = this.revealZoomedView.bind(this);
            var overlay = image.closest('.zoom-overlay-container');
            overlay.addEventListener('mouseleave', function (event) {
                this.hideZoomedView(i);
            }.bind(this));
            overlay.addEventListener('mousemove', function(event) {
                this._positionZoom(event, i);
            }.bind(this));

            var overlayMarker = document.createElement('div');
            overlayMarker.classList.add('zoom-overlay');
            overlay.appendChild(overlayMarker);
            this.overlays.push(overlay);
            this.overlayMarkers.push(overlayMarker);
        });
    }

    toggle() {
        if (this.enabled) {
            this.disable();
        }
        else {
            this.enable();
        }
    }

    enable() {
        if (this.trigger) {
            this.trigger.classList.add('active');
        }
        this.images.forEach(image => {
            image.addEventListener('mouseenter', image.event);
        });
        this.enabled = true;
    }

    disable() {
        if (this.trigger) {
            this.trigger.classList.remove('active');
        }
        this.images.forEach(image => {
            image.removeEventListener('mouseenter', image.event);
        });
        this.enabled = false;
    }

    revealZoomedView(event) {
        var image = event.target;
        var index = this.images.indexOf(image);
        var pos = image.getBoundingClientRect();
        var alignRect = this.aligner.getBoundingClientRect();
        if ((pos.left + pos.right) / 2 > (document.body.clientWidth / 2)) {
            this.zoomPanel.style.width = (alignRect.width + alignRect.x - 16) + "px";
            this.zoomPanel.style.left = "16px";
        }
        else {
            this.zoomPanel.style.width = (document.body.clientWidth - 16 - alignRect.x) + "px";
            this.zoomPanel.style.left = alignRect.x + "px";
        }
        var source = image.src;
        var queryPoint = source.indexOf("?");
        if (queryPoint > -1) {
            source = image.src.substring(0, queryPoint);
        }
        this.imageSize = {
            width: image.clientWidth,
            height: image.clientHeight
        };
        this._getImage(source)
            .then(zoomedSize => {
                this.zoomedSize = zoomedSize;
                if (this.imageSize.width < this.zoomedSize.width || this.imageSize.height < this.zoomedSize.height) {
                    this.zoomPanel.style.backgroundImage = 'url("' + source + '")';

                    this.zoomPanel.classList.add('active');
                    this._updateOverlay(event, index);
                }
            });
    }

    _getImage(url) {
        return new Promise((resolve, reject) => {
            if (this.imageSizes[url]) {
                resolve(this.imageSizes[url]);
            }
            else {
                var image = new Image();
                image.onload = function() {
                    var dimensions = {
                        width: image.width,
                        height: image.height
                    };
                    this.imageSizes[url] = dimensions;
                    resolve(dimensions);
                }.bind(this);
                image.onerror = (error) => {
                    reject(error);
                };
                image.src = url;
            }
        });
    }

    _updateOverlay(event, index) {
        var marker = this.overlayMarkers[index];
        var overlay = this.overlays[index];
        var image = this.images[index];
        overlay.style.height = (image.clientHeight * 100 / overlay.parentNode.clientHeight) + '%';
        overlay.classList.add('active');
        var ratio = this._getRatio();
        marker.style.width = ratio.x * 100 + '%';
        marker.style.height = ratio.y * 100 + '%';
        this._positionZoom(event, index);
    }

    _getRatio() {
        if (!this.zoomedSize) {
            return null;
        }
        return {
            x: Math.min(this.zoomPanel.clientWidth / this.zoomedSize.width, 1),
            y: Math.min(this.zoomPanel.clientHeight / this.zoomedSize.height, 1)
        };
    }

    _positionZoom(event, index) {
        window.requestAnimationFrame(function () {
            var ratio = this._getRatio();
            if (!ratio) {
                return;
            }
            var edgeLimit = {
                x: 1 - ratio.x,
                y: 1 - ratio.y
            }
            var center = {
                x: ratio.x / 2,
                y: ratio.y / 2
            }

            var pos;
            if (event.offsetX) {
                pos = {
                    x: event.offsetX / this.imageSize.width,
                    y: event.offsetY / this.imageSize.height
                };
            }
            else {
                var overlayRect = this.overlays[index].getBoundingClientRect();
                pos = {
                    x: (event.pageX - overlayRect.x) / this.imageSize.width,
                    y: (event.pageY - overlayRect.y) / this.imageSize.height
                }
            }
            var offset = {
                x: Math.min(Math.max(0, pos.x - center.x), edgeLimit.x),
                y: Math.min(Math.max(0, pos.y - center.y), edgeLimit.y)
            }
            this.overlayMarkers[index].style.transform = 'translate(' + (offset.x * this.imageSize.width) + 'px,' + (offset.y * this.imageSize.height) + 'px)';
            this.zoomPanel.style.backgroundPosition = (-offset.x * this.zoomedSize.width) + 'px ' + (-offset.y * this.zoomedSize.height) + 'px';
        }.bind(this));
    }

    hideZoomedView(index) {
        this.overlays[index].classList.remove('active');
        this.zoomPanel.classList.remove('active');
    }
}